var Album = {
    validForm: false,
    validReleaseDate: false,
    validDuration: false,
    validateReleaseDate: function(releaseDateElm, releaseDateError) {
        let releaseDate = $(releaseDateElm).val();
        // split the release date on /
        let dateAr = releaseDate.split('/');
        // if the split length is not 3, invalid input
        if (dateAr.length !== 3) {
            $(releaseDateError).text("Invalid date format supplied.  Must be MM/DD/YYYY").show();
            if ($(releaseDateElm).hasClass('border-gray-700')) {
                $(releaseDateElm).removeClass('border-gray-700').addClass('border-red-800');
            }
            this.validReleaseDate = false;
            return;
        } else {
            // hide the error if visible
            $(releaseDateError).hide().text('');
            if ($(releaseDateElm).hasClass('border-red-800')) {
                $(releaseDateElm).removeClass('border-red-800').addClass('border-gray-700');
            }
        }
        // check the array
        let isValid = true;
        $.each(dateAr, function(key, value) {
            // make sure each fragment are numbers
            if (isNaN(value)) {
                $(releaseDateError).text("Invalid date fragment:  " + value + ".  Must be a number.").show();
                if ($(releaseDateElm).hasClass('border-gray-700')) {
                    $(releaseDateElm).removeClass('border-gray-700').addClass('border-red-800');
                }
                this.validReleaseDate = false;
                isValid = false;
                return;
            }
            // make sure the length of each part is correct            
            if (key === 0 || key === 1) {
                if (value.length < 1 || value.length > 2) {
                    $(releaseDateError).text("Invalid date fragment:  " + value + ".  Day or month must be a one or two characters.").show();
                    if ($(releaseDateElm).hasClass('border-gray-700')) {
                        $(releaseDateElm).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    this.validReleaseDate = false;
                    isValid = false;
                    return;
                }
            }
            if (key === 2) {
                if (value.length != 4) {
                    $(releaseDateError).text("Invalid date fragment:  " + value + ".  Year must be four characters.").show();
                    if ($(releaseDateElm).hasClass('border-gray-700')) {
                        $(releaseDateElm).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    this.validReleaseDate = false;
                    isValid = false;
                    return;
                }
            }
            // make sure the month is valid
            if (key === 0) {
                if (parseInt(value) < 1 || parseInt(value) > 12) {
                    $(releaseDateError).text("Invalid month integer:  " + value + ".  Must be 1 to 12 only.").show();
                    if ($(releaseDateElm).hasClass('border-gray-700')) {
                        $(releaseDateElm).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    this.validReleaseDate = false;
                    isValid = false;
                    return;
                }
            }
            // make sure the day is valid
            if (key === 1) {
                if (parseInt(value) < 1 || parseInt(value) > 31) {
                    $(releaseDateError).text("Invalid day integer:  " + value + ".  Must be 1 to 31 only.").show();
                    if ($(releaseDateElm).hasClass('border-gray-700')) {
                        $(releaseDateElm).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    this.validReleaseDate = false;
                    isValid = false;
                    return;
                }
            }
            // make sure the day is valid
            if (key === 2) {
                let d = new Date();
                let year = d.getFullYear();
                if (parseInt(value) < 1960 || parseInt(value) > year) {
                    $(releaseDateError).text("Invalid year integer:  " + value + ".  Must be greater than 1960 but less than " + (year + 1) + ".").show();
                    if ($(releaseDateElm).hasClass('border-gray-700')) {
                        $(releaseDateElm).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    this.validReleaseDate = false;
                    isValid = false;
                    return;
                }
            }
        });
        if (isValid) {
            this.validReleaseDate = true;
        } else {
            this.validReleaseDate = false;
        }
        this.validateForm();
    },
    validateDuration: function(durationEl, durationError) {
        let duration = $(durationEl).val();
        let durAr = duration.split(":");
        // if the split length is not 2, invalid input
        if (durAr.length !== 2) {
            $(durationError).text("Invalid format supplied.  Must be MM:SS").show();
            if ($(durationEl).hasClass('border-gray-700')) {
                $(durationEl).removeClass('border-gray-700').addClass('border-red-800');
            }
            this.validDuration = false;
            this.validateForm();
            return;
        } else {
            // hide the error if visible
            $(durationError).hide().text('');
            if ($(durationEl).hasClass('border-red-800')) {
                $(durationEl).removeClass('border-red-800').addClass('border-gray-700');
            }
        }
        // check the array
        let isValid = true;
        $.each(durAr, function(key, value) {
            // make sure each fragment are numbers
            if (isNaN(value)) {
                $(durationError).text("Invalid timecode fragment:  " + value + ".  Must be a number.").show();
                if ($(durationEl).hasClass('border-gray-700')) {
                    $(durationEl).removeClass('border-gray-700').addClass('border-red-800');
                }
                this.validDuration = false;
                isValid = false;
                return;
            }
            // make sure the length of each part is correct (min)      
            if (key === 0) {
                if (value.length < 1 || value.length > 2) {
                    $(durationError).text("Invalid timecode fragment:  " + value + ".  Minutes must be a one or two characters.").show();
                    if ($(durationEl).hasClass('border-gray-700')) {
                        $(durationEl).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    this.validDuration = false;
                    isValid = false;
                    return;
                }
            }
            // make sure the length of each part is correct (sec)       
            if (key === 1) {
                if (value.length < 2 || value.length > 2) {
                    $(durationError).text("Invalid timecode fragment:  " + value + ".  Seconds must be two characters.").show();
                    if ($(durationEl).hasClass('border-gray-700')) {
                        $(durationEl).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    this.validDuration = false;
                    isValid = false;
                    return;
                }
            }
            // make sure the minute is valid
            if (key === 0) {
                if (parseInt(value) < 0) {
                    $(durationError).text("Invalid minutes integer:  " + value + ".  Must greater than 0.").show();
                    if ($(durationEl).hasClass('border-gray-700')) {
                        $(durationEl).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    this.validDuration = false;
                    isValid = false;
                    return;
                }
            }
            // make sure the second is valid
            if (key === 1) {
                if (parseInt(value) < 0 || parseInt(value) > 59) {
                    $(durationError).text("Invalid seconds integer:  " + value + ".  Must be 0 to 59 only.").show();
                    if ($(durationEl).hasClass('border-gray-700')) {
                        $(durationEl).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    this.validDuration = false;
                    isValid = false;
                    return;
                }
            }
        });
        if (isValid) {
            this.validDuration = true;
        } else {
            this.validDuration = false;
        }
        this.validateForm();
    },
    validateForm: function() {
        if (this.validReleaseDate && this.validDuration) {
            this.validForm = true;
            $('#submitAlbum, #editAlbum').removeAttr('disabled');
        } else {
            this.validForm = false;
            $('#submitAlbum, #editAlbum').attr('disabled', 'disabled');
        }
    },
    resetErrors: function() {
        $.each($('input'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
        $.each($('select'), function(key, value) {
            if ($(this).hasClass('border-red-800')) {
                $(this).removeClass('border-red-800').addClass('border-gray-700');
                $(this).parent().parent().find('span').hide();
                $('#messageDiv').removeClass('bg-red-800').removeClass('bg-green-800').hide();
            }
        });
    },
    addAlbum: function() {
        this.resetErrors();
        this.addAlbumPromise()
            .then((response) => {
                $('#messageDiv').addClass('bg-green-800').show();
                $('#message').html('Thank you for submitting ' + response.data.title + ' to the Codex.  We will review your submission as soon as possible.');
            })
            .catch((error) => {
                //console.log(error.response);
                let message = error.response.data.message;
                $('#message').text(message);
                $('#messageDiv').removeClass('bg-green-800').addClass('bg-red-800').show();

                $.each(error.response.data.errors, function(key, value) {
                    //console.log("key = " + key);
                    //console.log("value = " + value);
                    let messageText = '#' + key + "Error";
                    $(messageText).text(value).show();
                    if ($('#' + key).hasClass('border-gray-700')) {
                        $('#' + key).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    
                });
            });
    },
    addAlbumPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.title = $('#title').val();
            request.uid = $('#uid').val();
            request.artistId = $('#artistId').val();
            request.releaseDate = $('#releaseDate').val();
            request.details = $('#details').val();

            let formData = new FormData();
            let coverFile = document.getElementById('cover').files[0];

            if (document.getElementById('cover').files.length > 0)
                formData.append("cover", coverFile, coverFile.name);

            formData.append("title", request.title);
            formData.append("uid", request.uid);
            formData.append("artistId", request.artistId);
            formData.append("releaseDate", request.releaseDate);
            formData.append("details", request.details);

            // dynamically add the tracks
            let totalTracks = $('#track_count').val();
            formData.append("totalTracks", totalTracks);
            for(i = 1; i <= totalTracks; i++) {
                formData.append("track"+ i +"_title", $('#track'+ i +'_title').val());
                formData.append("track"+ i +"_duration", $('#track'+ i +'_duration').val());
                formData.append("track"+ i +"_lyrics", $('#track'+ i +'_lyrics').val());
            }

            // dynamically add the editions
            let totalEditions = $('#ed_count').val();
            formData.append("totalEditions", totalEditions);
            for(i = 1; i <= totalEditions; i++) {
                formData.append("ed"+ i +"_label", $('#ed'+ i +'_label').val());
                formData.append("ed"+ i +"_format", $('#ed'+ i +'_format').val());
                formData.append("ed"+ i +"_copies", $('#ed'+ i +'_copies').val());
                formData.append("ed"+ i +"_releaseDate", $('#ed'+ i +'_releaseDate').val());
                formData.append("ed"+ i +"_url", $('#ed'+ i +'_url').val());
            }

            window.axios.post('/submit/album', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    editAlbum: function() {
        this.resetErrors();
        this.editAlbumPromise()
            .then((response) => {
                $('#messageDiv').addClass('bg-green-800').show();
                $('#message').html(response.data.title + ' has been edited.');
            })
            .catch((error) => {
                //console.log(error.response);
                let message = error.response.data.message;
                $('#message').text(message);
                $('#messageDiv').removeClass('bg-green-800').addClass('bg-red-800').show();

                $.each(error.response.data.errors, function(key, value) {
                    //console.log("key = " + key);
                    //console.log("value = " + value);
                    let messageText = '#' + key + "Error";
                    $(messageText).text(value).show();
                    if ($('#' + key).hasClass('border-gray-700')) {
                        $('#' + key).removeClass('border-gray-700').addClass('border-red-800');
                    }
                    
                });
            });
    },
    editAlbumPromise: function() {
        return new Promise((resolve, reject) => {
            let request = {};
            request.title = $('#title').val();
            request.uid = $('#uid').val();
            request.id = $('#id').val();
            request.releaseDate = $('#releaseDate').val();
            request.details = $('#details').val();
            request.approved = $('#approved').val();

            let formData = new FormData();
            let coverFile = document.getElementById('cover').files[0];

            if (document.getElementById('cover').files.length > 0)
                formData.append("cover", coverFile, coverFile.name);

            formData.append("title", request.title);
            formData.append("uid", request.uid);
            formData.append("id", request.id);
            formData.append("releaseDate", request.releaseDate);
            formData.append("details", request.details);
            formData.append("approved", request.approved);

            // dynamically add the tracks
            let totalTracks = $('#track_count').val();
            formData.append("totalTracks", totalTracks);
            for(i = 1; i <= totalTracks; i++) {
                formData.append("track"+ i +"_title", $('#track'+ i +'_title').val());
                formData.append("track"+ i +"_duration", $('#track'+ i +'_duration').val());
                formData.append("track"+ i +"_lyrics", $('#track'+ i +'_lyrics').val());
            }

            // dynamically add the editions
            let totalEditions = $('#ed_count').val();
            formData.append("totalEditions", totalEditions);
            for(i = 1; i <= totalEditions; i++) {
                formData.append("ed"+ i +"_label", $('#ed'+ i +'_label').val());
                formData.append("ed"+ i +"_format", $('#ed'+ i +'_format').val());
                formData.append("ed"+ i +"_copies", $('#ed'+ i +'_copies').val());
                formData.append("ed"+ i +"_releaseDate", $('#ed'+ i +'_releaseDate').val());
                formData.append("ed"+ i +"_url", $('#ed'+ i +'_url').val());
            }

            window.axios.post('/curator/album/edit', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error)
            });
        });
    },
    addTrack: function() {
        // get the next track count
        let nextTrackNum = parseInt($('#track_count').val()) + 1;
        // set the next track count
        $('#track_count').val(nextTrackNum);
        // add track content to the tracks container
        $('#tracksContainer').append('<!-- track '+ nextTrackNum +' --><div id="track'+ nextTrackNum +'Row">'
            + '<div class="w-full px-3 mb-3">'
            + '<label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="track'+ nextTrackNum +'">'
            + 'Track '+ nextTrackNum
            + '</label>'
            + '<input class="appearance-none border bg-gray-900 border-gray-700 rounded w-full py-2 px-3 text-white leading-tight outline-none" id="track'+ nextTrackNum +'_title" name="track'+ nextTrackNum +'_title" value="" type="text" placeholder="Track '+ nextTrackNum +' Title">'
            + '<span class="text-red-700 text-sm hidden" id="track'+ nextTrackNum +'_titleError">Problem with title.</span>'
            + '</div>'
            + '<div class="w-full px-3 mb-3">'
            + '<input class="duration appearance-none border bg-gray-900 border-gray-700 rounded w-full py-2 px-3 text-white leading-tight outline-none" id="track'+ nextTrackNum +'_duration" name="track'+ nextTrackNum +'_duration" value="" type="text" placeholder="MM:SS" data-id="'+ nextTrackNum +'">'
            + '<span class="text-red-700 text-sm hidden" id="track'+ nextTrackNum +'_durationError">Problem with duration.</span>'
            + '</div>'
            + '<div class="w-full px-3 mb-3">'
            + '<textarea style="height: 200px;" class=" appearance-none border bg-gray-900 border-gray-700 rounded w-full py-2 px-3 text-white leading-tight outline-none" id="track'+ nextTrackNum +'_lyrics" name="track'+ nextTrackNum +'_lyrics" value="" type="text" placeholder="Track '+ nextTrackNum +' Lyrics"></textarea>'
            + '<span class="text-red-700 text-sm hidden" id="track'+ nextTrackNum +'_lyricsError">Problem with lyrics.</span>'
            + '</div>'
            + '</div><!-- /track '+ nextTrackNum +' -->');
    },
    delTrack: function() {
        // get the current track count
        let trackNum = parseInt($('#track_count').val());
        // don't delete track 1
        if (trackNum === 1) {
            return;
        }
        $('#track'+ trackNum +'Row').remove();
        let prevTrackNum = trackNum - 1;
        $('#track_count').val(prevTrackNum);
    },
    addEd: function() {
        // get the next ed count
        let nextEdNum = parseInt($('#ed_count').val()) + 1;
        // set the next ed count
        $('#ed_count').val(nextEdNum);
        // add track content to the tracks container
        $('#editionsContainer').append('<!-- edition '+ nextEdNum +' --><div id="ed'+ nextEdNum +'Row">'
            + '<div class="w-full px-3 mb-3">'
            + ' <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="ed'+ nextEdNum +'_label">'
            + '     Edition '+ nextEdNum 
            + ' </label>'
            + ' <input class="appearance-none border bg-gray-900 border-gray-700 rounded w-full py-2 px-3 text-white leading-tight outline-none" id="ed'+ nextEdNum +'_label" name="ed'+ nextEdNum +'_label" value="" type="text" placeholder="Label">'
            + ' <span class="text-red-700 text-sm hidden" id="ed'+ nextEdNum +'_labelError">Problem with label.</span>'
            + '</div>'
            + '<div class="w-full px-3 mb-3">'
            + '  <input class="appearance-none border bg-gray-900 border-gray-700 rounded w-full py-2 px-3 text-white leading-tight outline-none" id="ed'+ nextEdNum +'_format" name="ed'+ nextEdNum +'_format" value="" type="text" placeholder="Format: Digital, CD, Cassette, etc">'
            + '  <span class="text-red-700 text-sm hidden" id="ed'+ nextEdNum +'_formatError">Problem with format.</span>'
            + '</div>'
            + '<div class="w-full px-3 mb-3">'
            + '  <input class="appearance-none border bg-gray-900 border-gray-700 rounded w-full py-2 px-3 text-white leading-tight outline-none" id="ed'+ nextEdNum +'_copies" name="ed'+ nextEdNum +'_copies" value="" type="text" placeholder="Number of copies">'
            + '  <span class="text-red-700 text-sm hidden" id="ed'+ nextEdNum +'_copiesError">Problem with copies.</span>'
            + '</div>'
            + '<div class="w-full px-3 mb-3">'
            + '  <input class="date appearance-none border bg-gray-900 border-gray-700 rounded w-full py-2 px-3 text-white leading-tight outline-none" id="ed'+ nextEdNum +'_releaseDate" name="ed'+ nextEdNum +'_releaseDate" value="" type="text" placeholder="Release Date MM/DD/YYYY" data-id="'+ nextEdNum +'">'
            + '  <span class="text-red-700 text-sm hidden" id="ed'+ nextEdNum +'_releaseDateError">Problem with release date.</span>'
            + '</div>'
            + '<div class="w-full px-3 mb-3">'
            + '  <input class="appearance-none border bg-gray-900 border-gray-700 rounded w-full py-2 px-3 text-white leading-tight outline-none" id="ed'+ nextEdNum +'_url" name="ed'+ nextEdNum +'_url" value="" type="text" placeholder="https://">'
            + '  <span class="text-red-700 text-sm hidden" id="ed'+ nextEdNum +'_urlError">Problem with URL.</span>'
            + '</div></div>'
            + '<!-- /edition '+ nextEdNum +' -->');
    },
    delEd: function() {
        // get the current ed count
        let edNum = parseInt($('#ed_count').val());
        // don't delete ed 1
        if (edNum === 1) {
            return;
        }
        $('#ed'+ edNum +'Row').remove();
        let prevEdNum = edNum - 1;
        $('#ed_count').val(prevEdNum);
    }
}

$(document).ready(function() {
    // run the validation on the edit page
    if (window.location.pathname.indexOf("/curator/album/edit/") > -1) {
        Album.validateReleaseDate('#releaseDate', '#releaseDateError');
        Album.validateDuration('#track1_duration', '#track1_durationError');
        if (parseInt($('#track_count').val()) === 0) {
            Album.addTrack();
        }
        if (parseInt($('#ed_count').val()) === 0) {
            Album.addEd();
        }
    }    
    // validate the release date
    $('#releaseDate').on('blur', function(e) {
        Album.validateReleaseDate('#releaseDate', '#releaseDateError');
    });
    $(document).on('blur', '.date', function(e) {
        // get the ed number
        let edNum = $(this).data('id');
        Album.validateReleaseDate('#ed'+ edNum +'_releaseDate', '#ed'+ edNum +'_releaseDateError');
    });
    $(document).on('blur', '.duration', function(e) {
        // get the track number
        let trackNum = $(this).data('id');
        Album.validateDuration('#track'+ trackNum +'_duration', '#track'+ trackNum +'_durationError');
    });
    // submit the album
    $('#submitAlbum').on('click', function(e) {
        Album.addAlbum();
    });
    // edit the album
    $('#editAlbum').on('click', function(e) {
        Album.editAlbum();
    });
    // delete a track
    $('#delTrack').on('click', function(e) {
        e.preventDefault();
        Album.delTrack();
    });
    // add a track
    $('#addTrack').on('click', function(e) {
        e.preventDefault();
        Album.addTrack();
    });
    // delete an ed
    $('#delEd').on('click', function(e) {
        e.preventDefault();
        Album.delEd();
    });
    // add an ed
    $('#addEd').on('click', function(e) {
        e.preventDefault();
        Album.addEd();
    });
    // expand/collaspe for displaying lyrics
    $('.expand').on('click', function(e) {
        var lyrics = $(this).parent().next();
        var plus = $(this).find('.plus');
        var minus = $(this).find('.minus');
        if ($(lyrics).is(":visible")) {
            $(lyrics).slideUp('slow');
            $(minus).hide();
            $(plus).show();
        } else {
            $(lyrics).slideDown('slow');
            $(plus).hide();
            $(minus).show();
        }
    });
});